import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Foodie Guide- Recipe Webapp',
        projectDesc: 'This is a MERN Stack food recipe web application where you can search recipes by title or find them from your cuisine or meal. You can also share your own recipes with details and rate any recipes.',
        tags: ['React', 'Express JS', 'MongoDB','Node JS'],
        code: 'https://github.com/NusrathJahan58/mern-recipeapp',
        demo: 'https://mern-recipes.onrender.com/',
        image: "https://i.postimg.cc/Vk4yCCCH/f24d8daa-e7ac-4eec-9f9c-076b4d14df9a.png"
    },
    {
        id: 2,
        projectName: 'Reflection - Addiction Recovery Website',
        projectDesc: 'This is a drug addiction recovery website. It was built for a web developing contest. My contribution to this project was the navigation, front page, recovery and blog page and all the researches. The rest of the project was built by my teammate.',
        tags: ['HTML', 'CSS','Javascript', 'Bootstrap'],
        code: 'https://github.com/NusrathJahan58/Reflection',
        demo: 'https://nusrathjahan58.github.io/Reflection/',
        image: "https://i.postimg.cc/HnRpy78y/f100f3e6-bd5f-49c7-be3f-f6bc4ad56de7.png"
    },
    {
        id: 3,
        projectName: 'Grand Cafe- Restaurant Website',
        projectDesc: 'A restaurant website where you can find all the information about the restaurant and order your food online and make a reservation. This was my first project which got me inspired to follow this career.',
        tags: ['HTML', 'CSS','Javascript'],
        code: 'https://github.com/NusrathJahan58/GrandCafe-Restaurant',
        demo: 'https://nusrathjahan58.github.io/GrandCafe-Restaurant/',
        image: "https://i.postimg.cc/6qXqQmgv/62183ad2-6a9b-4037-a61c-1b72b608b42b.png"
    },
    {
        id: 4,
        projectName: 'Math Quizy Game',
        projectDesc: 'This is a fun mathemetical quiz game buit with HTML, CSS and Javascript. It was for exercise purpose.',
        tags: ['HTML', 'CSS','Javascript'],
        code: 'https://github.com/NusrathJahan58/MathQuizyGame',
        demo: 'https://nusrathjahan58.github.io/MathQuizyGame/',
        image: "https://i.postimg.cc/WzNDny8P/736ded32-6b0e-469a-9042-7ee8faadcaea.png"
    },
    {
        id: 5,
        projectName: 'Cuda- A Business Website',
        projectDesc: 'It is a PSD to HTML project. It was for exercise purpose.',
        tags: ['HTML', 'CSS','Javascript'],
        code: 'https://github.com/NusrathJahan58/Cuda--A-business-website',
        demo: 'https://nusrathjahan58.github.io/Cuda--A-business-website/',
        image: "https://i.postimg.cc/pTw9NTPR/68b5951c-1dfa-4fc1-a03e-dd6c38e2b527.png"
    },
    {
        id: 6,
        projectName: 'Football Club',
        projectDesc: 'It is a responsive website built for an assignment given by course instructor.',
        tags: ['HTML', 'CSS'],
        code: 'https://github.com/NusrathJahan58/Football-club',
        demo: 'https://nusrathjahan58.github.io/Football-club/',
        image: "https://i.postimg.cc/8cbTyP5y/019d6bee-2f5e-4edc-8ca1-79c498f49800.png"
    },
    {
        id: 7,
        projectName: 'Food Network',
        projectDesc: 'It is a basic HTML CSS website built for an assignment given by course instructor.',
        tags: ['HTML', 'CSS'],
        code: 'https://github.com/NusrathJahan58/food-network',
        demo: 'https://nusrathjahan58.github.io/food-network/',
        image: "https://i.postimg.cc/3RNpG0cy/0dfdc1e2-196f-415e-b937-b9b24a9bbae1.png"
    }
    
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/